export default {
  getList: '/v3/activity/advertisement',
  readNewAd: '/v3/activity/readNewAd'
}
